import { useCallback, useContext, useEffect, useRef } from 'react';
import { USER_ROLES } from '../../../../constants';
import { UserContext } from '../../../../context';

export const useUserFetch = ({ onSuccess }) => {
  const [userData, userActions] = useContext(UserContext);

  const isLoadedUserDetected = useRef();

  const { role } = userData;
  const { FETCH_USER_DATA } = userActions;

  useEffect(() => {
    if (isLoadedUserDetected.current && role === USER_ROLES.USER) {
      isLoadedUserDetected.current = false;

      onSuccess({ user: userData });
    }
  }, [onSuccess, role, userData]);

  const handleFetch = useCallback(async () => {
    isLoadedUserDetected.current = true;

    await FETCH_USER_DATA();
  }, [FETCH_USER_DATA]);

  return { fetch: handleFetch };
};
